import { render, staticRenderFns } from "./envGovDataMst.vue?vue&type=template&id=37c33aa7"
import script from "./envGovDataMst.vue?vue&type=script&lang=js"
export * from "./envGovDataMst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c33aa7')) {
      api.createRecord('37c33aa7', component.options)
    } else {
      api.reload('37c33aa7', component.options)
    }
    module.hot.accept("./envGovDataMst.vue?vue&type=template&id=37c33aa7", function () {
      api.rerender('37c33aa7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/air/mst/envGovDataMst.vue"
export default component.exports